"use strict";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledCloseWrapper = exports.StyledSelectList = exports.StyledSelectListWrapper = exports.StyledSelect = exports.StyledPillSelect = exports.StyledDefaultSelect = exports.StyledSelectIcon = exports.StyledSelectListActionButton = exports.StyledSelectListButtonsWrapper = exports.StyledSelectWrapper = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _colors = require("../../utils/colors");

var _List = require("../List");

var _Icon = require("../Icon");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _templateObject21() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0.5275rem;\n  right: 1.25rem;\n  opacity: 0.5;\n  display: flex;\n  align-items: center;\n\n  svg {\n    margin-left: 6px;\n    width: 1rem;\n    height: 1rem;\n    margin-top: 0.1rem;\n  }\n\n  @media screen and (min-width: ", ") {\n    display: none;\n  }\n"]);

  _templateObject21 = function _templateObject21() {
    return data;
  };

  return data;
}

function _templateObject20() {
  var data = _taggedTemplateLiteral(["\n      &:after {\n        display: block;\n        height: 2.5em;\n        ", "\n      }\n    "]);

  _templateObject20 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19() {
  var data = _taggedTemplateLiteral(["\n  cursor: initial;\n  overflow-y: auto;\n  min-height: 100%;\n  max-height: ", ";\n  ", "\n  position: relative;\n  padding-bottom: ", ";\n\n  @media screen and (max-width: ", ") {\n    max-height: unset;\n    padding-top: 71px;\n    position: unset;\n    padding-bottom: 5rem;\n  }\n\n  ", ";\n"]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  z-index: 1;\n  width: 100%;\n  text-align: left;\n  display: flex;\n  justify-content: center;\n\n  @media screen and (max-width: ", ") {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 100vh;\n    width: 100vw;\n    overflow-y: auto;\n  }\n"]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n  outline: none;\n  appearance: none;\n  -webkit-appearance: none;\n  ", ";\n\n  &:hover {\n    svg {\n      path:nth-of-type(1) {\n        fill: ", ";\n      }\n    }\n  }\n"]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n          background: ", ";\n          color: ", ";\n        "]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n          background: ", ";\n          border: 1px solid ", ";\n          color: ", ";\n\n          svg {\n            path:nth-of-type(1) {\n              fill: ", ";\n            }\n          }\n        "]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n  padding: 0.2rem 1rem;\n  border: 1px solid\n    ", ";\n  border-radius: 20px;\n  cursor: pointer;\n  position: relative;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 18px;\n  line-height: 27px;\n\n  ", "\n\n  ", ";\n\n  &:hover {\n    color: ", ";\n    background: ", ";\n    border-color: ", ";\n\n    svg {\n      path:nth-of-type(1) {\n        fill: ", ";\n      }\n    }\n  }\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  color: inherit;\n  justify-content: space-between;\n  align-items: center;\n  box-sizing: border-box;\n  outline: none;\n  margin: 0;\n  padding: ", ";\n  width: 100%;\n  font-size: inherit;\n  text-align: left;\n  border-bottom: ", ";\n  border-top: ", ";\n  border-left: ", ";\n  border-right: ", ";\n  border-radius: ", ";\n  outline: none;\n  background: ", ";\n\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  font-size: calc(4 / 3 * 1rem);\n  display: flex;\n  align-items: center;\n  ", "\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0;\n  ", "\n  ", "\n  ", "\n  float: left;\n  &:last-of-type {\n    float: right;\n  }\n\n  &:hover svg > path:nth-of-type(1) {\n    fill: ", ";\n  }\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n          position: relative;\n          margin-top: 1rem;\n        "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n      width: 340px;\n      margin-left: 50%;\n      transform: translateX(-50%);\n      margin-bottom: 0.05rem;\n    "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  z-index: 99;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  border-top-left-radius: ", ";\n  border-top-right-radius: ", ";\n  border-bottom-left-radius: ", ";\n  border-bottom-right-radius: ", ";\n  justify-content: space-between;\n  background: ", ";\n  padding: 1rem 0 0.5rem;\n\n  ", "\n  \n    @media screen and (max-width: ", ") {\n      ", "\n    }\n\n    :before {\n    position: absolute;\n    top: 0;\n    left: 0.5em;\n    right: 0.5em;\n    content: '';\n    height: 1px;\n    background: ", ";\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  text-align: center;\n  width: ", ";\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  transition: transform 0.15s linear;\n  ", "\n  ", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    ", "\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    :focus {\n      border-color: ", ";\n\n      ", "\n    }\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    :hover {\n      color: ", ";\n    }\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    :hover {\n      cursor: pointer;\n      border-color: ", ";\n      background: ", ";\n\n      ", "\n    }\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  svg {\n    path:nth-of-type(1) {\n      fill: ", ";\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var iconHoverStyle = function iconHoverStyle(props) {
  return (0, _styledComponents.css)(_templateObject(), props.theme.select.listButtons.hoverColor);
};

var hoverStyle = function hoverStyle(props) {
  return (0, _styledComponents.css)(_templateObject2(), (0, _colors.normaliseColor)(props.theme.select.border.hoverColor, props.theme), (0, _colors.getRGBOpacity)(props.theme.colors.actionPrimary300, 0.1), iconHoverStyle(props));
};

var listButtonsHoverStyle = function listButtonsHoverStyle(props) {
  return (0, _styledComponents.css)(_templateObject3(), props.theme.select.listButtons.hoverColor);
};

var focusStyle = function focusStyle(props) {
  return (0, _styledComponents.css)(_templateObject4(), (0, _colors.normaliseColor)(props.theme.select.border.focusColor, props.theme), iconHoverStyle(props));
};

var listPosition = function listPosition(props) {
  return (0, _styledComponents.css)(_templateObject5(), props.listPosition === 'top' ? "bottom: calc(100% + ".concat(props.theme.select.border.width, ");") : "top: calc(100% + ".concat(props.theme.select.border.width, ");"));
};

var AnimationArrowRotation = (0, _styledComponents.css)(_templateObject6(), function (props) {
  return props.open && "\n    transform: rotate(-180deg);\n  ";
}, function (props) {
  return !props.open && "\n    transform: rotate(0deg);\n  ";
});

var StyledSelectWrapper = _styledComponents.default.div(_templateObject7(), function (props) {
  return props.width;
});

exports.StyledSelectWrapper = StyledSelectWrapper;

var StyledSelectListButtonsWrapper = _styledComponents.default.div(_templateObject8(), function (props) {
  return props.theme.list.border.radius || props.theme.list.border.topLeftRadius;
}, function (props) {
  return props.theme.list.border.radius || props.theme.list.border.topRightRadius;
}, function (props) {
  return props.theme.list.border.radius || props.theme.list.border.bottomLeftRadius;
}, function (props) {
  return props.theme.list.border.radius || props.theme.list.border.bottomRightRadius;
}, function (props) {
  return (0, _colors.normaliseColor)(props.theme.list.background.color, props.theme);
}, function (props) {
  return props.styleAs === 'pill' && (0, _styledComponents.css)(_templateObject9());
}, function (props) {
  return props.theme.breakpoints && props.theme.breakpoints.sm;
}, function (props) {
  return props.styleAs === 'pill' && (0, _styledComponents.css)(_templateObject10());
}, function (props) {
  return props.theme.dark ? props.theme.colors.white : (0, _colors.normaliseColor)(props.theme.list.border.color, props.theme);
});

exports.StyledSelectListButtonsWrapper = StyledSelectListButtonsWrapper;

var StyledSelectListActionButton = _styledComponents.default.a(_templateObject11(), function (props) {
  return !props.disabled && listButtonsHoverStyle(props);
}, function (props) {
  return props.disabled && "opacity: 0.3;";
}, function (props) {
  return !props.disabled && "cursor: pointer;";
}, function (props) {
  return !props.disabled && props.theme.select.listButtons.hoverColor;
});

exports.StyledSelectListActionButton = StyledSelectListActionButton;
var StyledSelectIcon = (0, _styledComponents.default)(_Icon.Icon)(_templateObject12(), AnimationArrowRotation);
exports.StyledSelectIcon = StyledSelectIcon;
var StyledDefaultSelect = (0, _styledComponents.css)(_templateObject13(), function (props) {
  return props.theme.select.padding;
}, function (props) {
  return "".concat(props.theme.select.border.bottom, " ").concat(props.theme.select.border.style, " ").concat(props.borderColor || (0, _colors.normaliseColor)(props.theme.select.border.color, props.theme));
}, function (props) {
  return "".concat(props.theme.select.border.top, " ").concat(props.theme.select.border.style, " ").concat(props.borderColor || (0, _colors.normaliseColor)(props.theme.select.border.color, props.theme));
}, function (props) {
  return "".concat(props.theme.select.border.left, " ").concat(props.theme.select.border.style, " ").concat(props.borderColor || (0, _colors.normaliseColor)(props.theme.select.border.color, props.theme));
}, function (props) {
  return "".concat(props.theme.select.border.right, " ").concat(props.theme.select.border.style, " ").concat(props.borderColor || (0, _colors.normaliseColor)(props.theme.select.border.color, props.theme));
}, function (props) {
  return props.theme.select.border.radius;
}, function (props) {
  return (0, _colors.normaliseColor)(props.theme.select.background.color, props.theme);
}, function (props) {
  return props.disabled && "opacity: 0.3;";
}, function (props) {
  return !props.disabled && hoverStyle(props);
}, function (props) {
  return !props.disabled && focusStyle(props);
});
exports.StyledDefaultSelect = StyledDefaultSelect;
var StyledPillSelect = (0, _styledComponents.css)(_templateObject14(), function (props) {
  return props.theme.dark ? props.theme.pillSelector.borderColor.withDarkBg : props.theme.pillSelector.borderColor.withLighBg;
}, function (props) {
  return props.disabled && "opacity: 0.3;";
}, function (props) {
  return props.hasValue ? (0, _styledComponents.css)(_templateObject15(), props.theme.pillSelector.hoverColor, props.theme.pillSelector.hoverColor, props.theme.colors.white, props.theme.colors.white) : (0, _styledComponents.css)(_templateObject16(), props.theme.dark && "none" || props.theme.colors.white, props.theme.dark && props.theme.colors.white);
}, function (props) {
  return !props.disabled && !props.hasValue && props.theme.pillSelector.hoverColor;
}, function (props) {
  return !props.disabled && props.hasValue && props.theme.colors.actionPrimary500;
}, function (props) {
  return props.theme.dark && props.theme.pillSelector.hoverColor;
}, function (props) {
  return !props.theme.dark && !props.disabled && !props.hasValue && props.theme.pillSelector.hoverColor;
});
exports.StyledPillSelect = StyledPillSelect;

var StyledSelect = _styledComponents.default.button(_templateObject17(), function (props) {
  return props.styleAs === 'pill' ? StyledPillSelect : StyledDefaultSelect;
}, function (props) {
  return !props.disabled && !props.hasValue && props.theme.pillSelector.hoverColor;
});

exports.StyledSelect = StyledSelect;

var StyledSelectListWrapper = _styledComponents.default.div(_templateObject18(), function (props) {
  return props.theme.breakpoints && props.theme.breakpoints.sm;
});

exports.StyledSelectListWrapper = StyledSelectListWrapper;
var StyledSelectList = (0, _styledComponents.default)(_List.List)(_templateObject19(), function (props) {
  return props.styleFor === 'default' ? '10.6em' : props.height || 'auto';
}, function (props) {
  return listPosition(props);
}, function (props) {
  return props.multiple && '4rem';
}, function (props) {
  return props.theme.breakpoints && props.theme.breakpoints.sm;
}, function (props) {
  return props.styleFor === 'default' && (0, _styledComponents.css)(_templateObject20(), props.multiple && "content: '';");
});
exports.StyledSelectList = StyledSelectList;

var StyledCloseWrapper = _styledComponents.default.div(_templateObject21(), function (props) {
  return props.theme.breakpoints.sm;
});

exports.StyledCloseWrapper = StyledCloseWrapper;